import styled from "styled-components";

type ComponentProps = { dark?: boolean };

const Link = styled.a<ComponentProps>`
    text-transform: uppercase;
    color: ${({ dark }) => (dark ? "#fff" : "#000")};
    border: 2px solid #FF5701;
    text-decoration: none;
    font-family: "Inter", sans-serif;
    font-weight: bold;
    font-size: 0.85rem;
    border-radius: 100px;
    padding: 10px 30px;
    background: none;
    font-weight: bold !important;
`;

type ButtonProps = {
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    href?: string;
    dark?: boolean;
    [key: string]: any;
};

const Button: React.FC<ButtonProps> = ({ onClick, href, children, dark = false, ...props }) => {
    return (
        <>
            {href ? (
                <Link dark={dark} {...props} href={href}>
                    {children}
                </Link>
            ) : (
                <Link as="button" dark={dark} type="button" {...props} onClick={onClick}>
                    {children}
                </Link>
            )}
        </>
    );
};

export default Button;
